// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"677de09d","3942":"322d9f25","4044":"58694f3d","5081":"322d9f25","5173":"38147317","8948":"42c036b3"}[chunkId] + ".chunk.css";
};